import { Dispatch, SetStateAction } from 'react';
import { DataSourcesTypes } from '@frontend/api-data-sources';
import { PersonTypes } from '@frontend/api-person';
import { UsePopoverDialogResponse } from '@frontend/design-system';

export enum PatientSelectorScreenEnum {
  PERSON_SEARCH = 'PERSON_SEARCH',
  PERSON_NOTES = 'PERSON_NOTES',
  CUSTOM_CONTACT = 'CUSTOM_CONTACT',
}

export type PersonLastNameLetterMap = {
  [letter: string]: string[];
};

type AtLeastOne<T, U = { [K in keyof T]: Pick<T, K> }> = Partial<T> & U[keyof U];

type FieldName =
  | 'firstName'
  | 'lastName'
  | 'dateOfBirth'
  | 'gender'
  | 'email'
  | 'source'
  | 'phoneNumber'
  | 'notes'
  | 'clientLocationId';

type Fields<T extends string> = AtLeastOne<{
  [key in T]: {
    value: string;
    required?: boolean;
  };
}>;

export type FormFields = Fields<FieldName>;

type CustomContactFormFieldName =
  | 'firstName'
  | 'lastName'
  | 'dateOfBirth'
  | 'gender'
  | 'email'
  | 'phoneNumber'
  | 'notes';

export type CustomContactFormFields = Fields<CustomContactFormFieldName>;

export type PersonSelectorFormValues = AtLeastOne<{
  [key in FieldName]: string;
}> & { personId?: string };

export type AddToListHandlerParamsType = Pick<PersonSelectorFormValues, 'personId' | 'notes'> & { isNew?: boolean };

export type PersonSelectorPropsType = {
  setSelectedPerson: Dispatch<SetStateAction<TransformedLegacyPerson | null>>;
  formFields: FormFields;
  dataSources: DataSourcesTypes.DataSource[] | undefined;
  personSelectorScreen: PatientSelectorScreenEnum;
  setPersonSelectorScreen: Dispatch<SetStateAction<PatientSelectorScreenEnum>>;
  clientLocationIds?: DataSourcesTypes.AccessDataResponse['ClientLocations'];
};

export type UsePersonSelectorReturnType = {
  selectedPerson: TransformedLegacyPerson | null;
  personSelectorDialogProps: UsePopoverDialogResponse;
  personSelectorProps: PersonSelectorPropsType;
};

export interface TransformedLegacyPerson extends Omit<PersonTypes.Person, 'Status'> {
  SourceTenantID?: string;
  // This is a temporary fix as changing Status in PersonTypes.Person type will cause Contact Chip to render all tag on Contacts page,
  // Need clarification from Design before updating that
  Status: 'Active' | 'Inactive' | 'Prospective' | 'Non_patient';
}

export type SourceTenantListItem = {
  sourceTenantId?: string;
  parentSourceTenantId?: string;
  sourceId?: string;
  name?: string;
  pmsName?: string;
};
